import { lazy } from "react";

export * from "./SVGRenderer";
export const GenericIcon = lazy(() => import("./GenericIcon"));
